// extracted by mini-css-extract-plugin
export default {"disableForceTouch":"image_disableForceTouch__r0eR2","imageButton":"image_imageButton__0mgj2"};